import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { WorkOrder, CustomFieldsConfiguration } from '.././wo-models';
// import { WoUpdater, WoUpdaterService } from '.././wo-updater.service';


import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { PopupInit } from '../../shared/init-popup';

import { BaseComponent } from '../../shared/base.component';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
//import { Customerdetails, CustomerDetailsListEntity, filteroptions } from '.././work-order-models';
import { LoaderService } from '../../shared/loader.service';
import { PagerList, GlobalInfo, FPMessage, Severities, RoleAccess, PageKey } from '../.././shared/shared.model';

import { PartLookup, PartLookupList, PartLookupFilter, BrandList, ModelList } from '../../work-order/work-order-models';
import { WoService } from '../../work-order/work-order.service';
import { Paginator } from 'primeng/primeng';
import { Table } from 'primeng/table';
declare let jsPDF;

@Component({
  // moduleId: module.id,
  selector: 'part-lookup',
  templateUrl: 'part-lookup.component.html'
})
export class PartLookupComponent extends BaseComponent implements OnInit {
  public Brand = new FormControl();
  public Model = new FormControl();
  public PartNo = new FormControl();
  public Description = new FormControl();

  public griddetails: PartLookupList;
  public details: PartLookup;
  public filterdetails: PartLookupFilter;

  public rows: number;
  public page: number;
  public order: string;
  public sortby: string;
  public rowsperOptions: any;
  public getRows: number;
  filteroptionId: number = 1;
  stacked: boolean;
  togglelist: boolean = false;
  @ViewChild('dt') dt: any;
  pagerList: PagerList;
  cols: any[];

  //selectedId: Customerdetails;
  @Output() done = new EventEmitter();
  @Output() CustID = new EventEmitter();

  public brand: BrandList[] = [];
  public model: ModelList[] = [];

  partId: number;

  @ViewChild('paginator') paginator: Paginator;

  viewpartss: boolean = false;
  @Input() vendorId?: number = null;
  constructor(protected translateService: TranslateService, private loaderservice: LoaderService, protected sharedService: SharedService
    , protected woService: WoService) {
    super(sharedService, translateService)
    this.rowsperOptions = this.sharedService.getRowsPerOptions();
    this.getRows = this.sharedService.getRows();

  }
  ngOnInit() {
            //Set columns for grid
            this.translate.get(['PARTNO', 'DESCRIPTION', 'CATEGORY', 'PARTTYPE', 'MODEL', 'BRAND','SERIALIZED','STATUS','View']).subscribe(s => {
              this.cols = [
                  {field: 'PartNo', header: s.PARTNO },
                  {field: 'Description', header: s.DESCRIPTION },
                  {field: 'Category', header: s.CATEGORY },
                  {field: 'PartType', header: s.PARTTYPE },
                  {field: 'Model', header: s.MODEL },
                  {field: 'Brand', header: s.BRAND },
                  {field: 'Serialized', header: s.SERIALIZED },
                  {field: 'Status', header: s.STATUS },
                  {field: '', header: s. View}
              ];
          });

    if (this.details == null) {
      this.details = new PartLookup;
    }
    if (this.griddetails == null) {
      this.griddetails = new PartLookupList;
    }
    if (this.filterdetails == null) {
      this.filterdetails = new PartLookupFilter;
    }

    this.rows = this.getRows;
    this.page = 0;
    this.order = "Category";
    this.sortby = "Asc";
    this.getPartlist();

    this.woService.getBrandList(super.globalInfo().CompanyId,this.vendorId).subscribe(resp => { this.brand = resp });

    this.Brand.valueChanges.subscribe(value => {
      if (value != 0) {
        this.woService.getModelList(super.globalInfo().CompanyId, value).subscribe(resp => { this.model = resp });
      }
      else {
        this.model = [];
      }
      this.Model.setValue('');
    });

    this.Brand.setValue('');
    this.Model.setValue('');

  } //onInit ends
  exportCSV(dt:Table) {
    debugger;
    this.filterdetails.StartRecord = null;
    this.filterdetails.EndRecord = null;
    let x = this.griddetails.PartLookupLists;

    this.woService.getPartLookupList(this.filterdetails).subscribe(resp => {
      this.griddetails.TotalRecord = resp.TotalRecord;
      let data = resp.PartLookupLists.map(m => {
        m.Status = m.IsActive ? 'Active' : 'Inactive';
        m.Serialized = m.IsSerialized ? 'Yes' : 'No';
        return m
      })
      this.griddetails.PartLookupLists = data;
      this.dt.value = this.griddetails.PartLookupLists;
      this.dt.exportCSV();
      this.griddetails.PartLookupLists = x;
      this.dt.value = this.griddetails.PartLookupLists;
    })
  }

  exportdata(dt:Table) {
    this.filterdetails.StartRecord = 0;
    this.filterdetails.EndRecord = 0;
    let x = this.griddetails.PartLookupLists;
    this.woService.getPartLookupList(this.filterdetails).subscribe(resp => {
      this.griddetails = resp;
      let data = resp.PartLookupLists.map(m => {
        m.Status = m.IsActive ? 'Active' : 'Inactive';
        m.Serialized = m.IsSerialized ? 'Yes' : 'No';
        return m
      })

      this.convert(this.griddetails.PartLookupLists);
      this.griddetails.PartLookupLists = x;
    })
  }
  convert(partdetails: any) {
    var item = partdetails;
    var doc = new jsPDF('l', 'pt', 'a4');
    var col = [this.translate.instant('PART'), this.translate.instant('DESCRIPTION'), this.translate.instant('CATEGORY'), this.translate.instant('PARTTYPE'), this.translate.instant('MODEL'), this.translate.instant('BRAND'), this.translate.instant('SERIALIZED'), this.translate.instant('STATUS')];
    var rows = [];
    item.forEach(f => {
      var temp = [f.PartNo, f.Description, f.Category, f.PartType, f.Model, f.Brand, f.Serialized, f.Status];
      rows.push(temp);
    })
    doc.autoTable(col, rows, { tableWidth: 'auto', columnWidth: 'auto', styles: { overflow: 'linebreak' } });
    doc.save('PartLookup.pdf');
  }
  exportExcel(dt:Table) {
    this.filterdetails.StartRecord = 0;
    this.filterdetails.EndRecord = 0;
    let x = this.griddetails.PartLookupLists;
    this.woService.getPartLookupList(this.filterdetails).subscribe(resp => {
      this.griddetails = resp;
      let data = resp.PartLookupLists.map(m => {
        m.Status = m.IsActive ? 'Active' : 'Inactive';
        m.Serialized = m.IsSerialized ? 'Yes' : 'No';
        return m
      })
      if (this.griddetails.PartLookupLists && this.griddetails.PartLookupLists.length > 0) {
        let columns = 'PartNo as [' + this.translate.instant("PART") + '],Description as [' + this.translate.instant("DESCRIPTION") +
          '],Category as [' + this.translate.instant('CATEGORY') + '],PartType as [' + this.translate.instant('PARTTYPE') + '],Model as [' + this.translate.instant('MODEL') + '],Brand as [' + this.translate.instant('BRAND') + '],Serialized as ' + this.translate.instant('SERIALIZED') + ',Status as ' + this.translate.instant('STATUS') + '';
        this.sharedService.exportExcel('PartLookup', 'PartLookup.xlsx', columns, this.griddetails.PartLookupLists);
      }
      else {
        this.sharedService.notification.emit({
          severity: 'info',
          summary: this.translate.instant('INFOMESSAGE'),
          detail: this.translate.instant('NODATATOEXPORT')
        })
      }
      this.griddetails.PartLookupLists = x;
    })
  }

  getPartlistSearch() {

    this.rows = this.getRows;
    this.page = 0;
    this.order = "Category";
    this.sortby = "Asc";
    this.getPartlist();
  }

  getPartlist() {
    debugger;
    this.filterdetails.SortBy = this.sortby;
    this.filterdetails.OrderBy = this.order;
    this.filterdetails.StartRecord = this.page;
    this.filterdetails.EndRecord = this.rows;
    this.filterdetails.CompanyID = this.globalInfo().CompanyId;
    this.filterdetails.BrandId = this.Brand.value;
    this.filterdetails.ModelId = this.Model.value;
    this.filterdetails.PartNo = this.PartNo.value;
    this.filterdetails.Description = this.Description.value;
    this.filterdetails.vendorId = this.vendorId;

    this.loaderservice.show();
    this.woService.getPartLookupList(this.filterdetails).subscribe(resp => {
      this.loaderservice.hide();
      this.griddetails = resp;
      let data = resp.PartLookupLists.map(m => {
        m.Status = m.IsActive ? 'Active' : 'Inactive';
        m.Serialized = m.IsSerialized ? 'Yes' : 'No';
        return m;
      })
      this.griddetails.PartLookupLists = data;
    }, e => {
      this.loaderservice.hide();
    });

    this.paginator.first = 0;

  }

  togglechange() {
    super.toggleCollapse();
    this.togglelist = this.togglelist == true ? false : true
  }

  paginate(event) {
    this.filterdetails.SortBy = this.sortby;
    this.filterdetails.OrderBy = this.order;
    this.filterdetails.StartRecord = event.page;
    this.page = event.page;
    this.filterdetails.EndRecord = event.rows;
    this.rows = event.rows;

    this.filterdetails.CompanyID = this.globalInfo().CompanyId;
    this.filterdetails.BrandId = this.Brand.value;
    this.filterdetails.ModelId = this.Model.value;
    this.filterdetails.PartNo = this.PartNo.value;
    this.filterdetails.Description = this.Description.value;
    this.filterdetails.vendorId = this.vendorId;
    this.woService.getPartLookupList(this.filterdetails).subscribe(resp => {
      this.griddetails = resp;
      let data = resp.PartLookupLists.map(m => {
        m.Status = m.IsActive ? 'Active' : 'Inactive';
        m.Serialized = m.IsSerialized ? 'Yes' : 'No';
        return m
      })
      this.griddetails.PartLookupLists = data;
    });
  }
  sort(event) {
    if (event.order == 1)
      this.sortby = "Asc";
    else
      this.sortby = "Desc";
    this.filterdetails.SortBy = this.sortby;
    this.filterdetails.OrderBy = event.field;
    this.order = event.field;
    this.filterdetails.StartRecord = this.page;
    this.filterdetails.EndRecord = this.rows;

    this.filterdetails.CompanyID = this.globalInfo().CompanyId;
    this.filterdetails.BrandId = this.Brand.value;
    this.filterdetails.ModelId = this.Model.value;
    this.filterdetails.PartNo = this.PartNo.value;
    this.filterdetails.Description = this.Description.value;
    this.filterdetails.vendorId = this.vendorId;
    this.woService.getPartLookupList(this.filterdetails).subscribe(resp => {
      this.griddetails = resp;
      let data = resp.PartLookupLists.map(m => {
        m.Status = m.IsActive ? 'Active' : 'Inactive';
        m.Serialized = m.IsSerialized ? 'Yes' : 'No';
        return m
      })
      this.griddetails.PartLookupLists = data;
    });
  }



  onRowSelect(value) {
    debugger;
    if (value.data == undefined) {
      value.data = value
    }

    this.done.emit(value)//value.data.CustomerId);
  }

  closePopup() {
    this.done.emit(0);
  }

  viewparts(data: any, e: Event) {
    this.partId = data.PartId;
    this.viewpartss = true;
    e.stopPropagation();
    e.preventDefault();
  }

  closepartspreview(res: any) {
    this.viewpartss = false;
  }

}